import { useHealthInsuranceValues } from './HealthInsuranceContext'

import { MIN_AGE_HEALTH_INSURANCE } from './utils'
import { EditPersonsFields } from '../PersonsFields'

export const EditPersons = () => {
  const { isEditable } = useHealthInsuranceValues()

  return (
    <EditPersonsFields
      minAge={MIN_AGE_HEALTH_INSURANCE}
      isEditable={isEditable}
      isDisabledBirthDate
      showResident
    />
  )
}
